module.exports = __webpack_public_path__ + "static/media/kai-beco.943bdb7f.png";